import React from "react";
import ReactSelect, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { updateCampaignSorting } from "../../VideoActions";
const selectedIcon =
  require("@src/assets/images/icons/selected-icon.png").default;

const style = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: null,
    borderColor: "#783ad0",
    backgroundColor: "none",
    cursor: "pointer",
    width: "118px",
    minHeight: "24px",
    maxHeight: "24px",
    "&:hover": {
      borderColor: "#783ad0",
    },
  }),

  valueContainer: (provided) => ({
    borderColor: "#783ad0",
    ...provided,
    fontSize: "10px",
    paddingLeft: "2px",
    marginTop: "-2px",
  }),

  option: (provided, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...provided,
      cursor: "pointer",
      color: isSelected ? "black" : "black",
      backgroundColor: "white",
      fontSize: "10px",
      padding:"5px 12px"
    };
  },
  dropdownIndicator: (provided, state) => ({
    ...provided,
    position: "absolute",
    right: "-4px",
    top: "-5px",
    width: "30px",
    height: "24px",
  }),
  menu: (provided) => ({
    ...provided,
    cursor: "pointer",
    width: "118px",
    color: "black",
    fontSize: "10px",
    padding: "0px 7px",
    border: "1px solid #783AD0",
  }),
};

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      {props.isSelected && (
        <img
          src={selectedIcon}
          alt="Selected"
          style={{ marginRight: "5px", marginLeft: "-12px" }}
          width={7}
        />
      )}
      {props.data.label}
    </components.Option>
  );
};

const sortByOptions = [
  {
    value: "sort_by",
    label: <span style={{ color: "rgba(230, 37, 128, 1)" }}>Sort by</span>,
    isHeading: true,
    isDisabled: true,
  },
  { value: "MODIFIDED", label: "Last Modified" },
  { value: "ALPHABETICAL", label: "Alphabetical" },
  { value: "OPENED", label: "Last Opened" },
  {
    value: "",
    label: (
      <div
        style={{
          borderBottom: "1px solid #E9EAEB",
          width: "106px",
          marginLeft: "-18px",
        }}
      ></div>
    ),
    isDisabled: true,
  },
  {
    value: "order",
    label: <span style={{ color: "rgba(230, 37, 128, 1)" }}>Order</span>,
    isHeading: true,
    isDisabled: true,
  },
  { value: "NEW", label: "Oldest First" },
  { value: "OLD", label: "Newest First" },
];

export default () => {
  const dispatch = useDispatch();
  const campaignSortBy = useSelector(
    (state) => state.videoPageStates.campaignSortBy
  );

  const handleChange = (selectedOption) => {
    dispatch(updateCampaignSorting(selectedOption.value));
  };

  return (
    <ReactSelect
      onChange={handleChange}
      value={sortByOptions.find((option) => option.value === campaignSortBy)}
      options={sortByOptions}
      components={{ Option: CustomOption }}
      styles={style}
    />
  );
};
